import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormArray, FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ClipboardService } from 'ngx-clipboard';
import { UtilsService } from 'src/app/services/utils.service';
import { LlavesService } from 'src/app/services/llaves.service';

@Component({
  selector: 'app-unirllavemodal',
  templateUrl: './unirllavemodal.component.html',
  styleUrls: ['./unirllavemodal.component.css']
})
export class UnirllavemodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private clipboard: ClipboardService, private llavesService: LlavesService) {
  }

  ngOnInit(): void {
    let listaFragmentos = [];
    for (let i = 1; i <= this.data.fragmentos; i++) {
      listaFragmentos.push({ posicion: i, fragmento: '' });
    }
    this.form = this.formService.getUnirFragmentosLlaveModalForm(this.data, listaFragmentos);
  }

  get itemValues(): FormArray {
    return this.form.get('items') as FormArray;
  }

  accept() {
    let llavePrivada = '';
    this.form.value.items.map((item) => {
      llavePrivada += item.fragmento;
    });
    if (this.form.value.llavePrivada !== llavePrivada) {
      this.alert.error('Los fragmentos de la llave no coinciden con la llave privada, verifique sus datos y la posicion de cada llave', false);
    } else {
      this.downloadKeyFile(this.form.value.llavePrivada, 'LlavePrivadaCompleta');
      this.close();
    }
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  downloadKeyFile(llave, nombreArchivo) {
    let file = new Blob([llave], { type: '.txt' });
    let a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

}
